import { Table, Tag } from "antd";
import styled from "styled-components";

export const StyledTag = styled(Tag)<{ $textColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 66px;
  height: 16px;
  color: ${(props) => props.$textColor};
`;

export const StyledTable = styled(Table)`
  .ant-table-header .ant-table-cell {
    border-bottom: 1px dashed #d7dce9;
    font-size: 12px;
    font-weight: 400;
    background-color: #f7f9fe;
    color: #6a7695;
  }

  .ant-table-row:nth-last-child(2) {
    & .ant-table-cell {
      border-bottom: none;
    }
  }

  .ant-table-container {
    background-color: #f7f9fe;
  }

  && .ant-table-cell {
    border-bottom: 1px dashed #d7dce9;
  }

  .ant-table-body::-webkit-scrollbar {
    width: 0;
  }
`;
